import { clearAuthData } from './storage';
import { clearAuthCookies } from './sessionCleanup';
import toast from 'react-hot-toast';

/**
 * Logs out the user globally (from anywhere, including non-React code)
 * - Clears auth cookies (HttpOnly cookies)
 * - Clears auth tokens from sessionStorage
 * - Clears sessionStorage entirely
 * - Removes persisted Redux state from localStorage (persist:root)
 * - Redirects to /login
 */
export function globalLogout(redirectPath = '/login', showMessage = false) {
  try {
    console.log('[globalLogout] Logging out user');
    if (showMessage && typeof window !== 'undefined') {
      toast('You have been logged out.');
    }
    // Clear HttpOnly cookies
    clearAuthCookies();
    clearAuthData();
    if (typeof window !== 'undefined') {
      window.sessionStorage.clear();
      window.localStorage.removeItem('persist:root');
      window.localStorage.removeItem('envType');
      console.log('[globalLogout] Redirecting to:', redirectPath);
      window.location.href = redirectPath;
    }
  } catch {
    console.error('[globalLogout] Error during logout');
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem('envType');
      window.localStorage.clear();
      window.sessionStorage.clear();
      clearAuthCookies();
      window.location.href = redirectPath;
    }
  }
}

/**
 * Clears auth tokens and cookies when tab/browser closes (without redirect)
 * - Clears auth cookies (HttpOnly cookies)
 * - Clears auth tokens from sessionStorage (auto-cleared by browser anyway)
 * - Clears sessionStorage entirely
 * - No redirect since page is closing
 *
 * Note: This is called on beforeunload event
 */
export function logoutOnTabClose() {
  try {
    console.log('[logoutOnTabClose] Tab closing - clearing auth');
    // Clear HttpOnly cookies immediately
    clearAuthCookies();
    clearAuthData();
    if (typeof window !== 'undefined') {
      window.sessionStorage.clear();
      window.localStorage.removeItem('persist:root');
      window.localStorage.removeItem('envType');
      // Don't redirect - page is closing
    }
  } catch {
    // Silently fail on tab close
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.clear();
        window.sessionStorage.clear();
      } catch {
        // Final fallback
      }
    }
  }
}
